<template>
  <div class="view-search">
    <input
      type="search"
      class="view-search-input"
      :value="modelValue"
      placeholder="Search"
      aria-label="Search records"
      @input="$emit('update:modelValue', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { type: String, default: '' }
  },
  emits: ['update:modelValue']
}
</script>

<style>
.view-search {
  margin-bottom: 8px;
}

.view-search-input {
  width: 100%;
  max-width: 320px;
  border: 1px solid #ced4da;
  background: #fff;
  color: #212529;
  border-radius: 4px;
  padding: 6px 10px;
  font-size: 0.95rem;
  line-height: 1.5;
}

.view-search-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.15);
}
</style>
